import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ExcelService,
  ReportService,
  SalesPlanService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "party-sales-order-report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./PartyOrderQtyReport.html",
})
export class PartySalesQtyReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  dataList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  exceldata: any;
  filter = {
    season_id: 0,
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "agent_name",
    orderDir: "asc",
  };
  finyearList: any[];
  agentList: any[];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;

  filterExpand = false;
  filterData: any = {
    fin_id: 3,
    genLedid: "",
    //company_id: 0
  };
  agentList$ = [];
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private combo: Combo2Service,
    private salesplanservice: SalesPlanService,
    private reportService: ReportService,
    public toasterService: ToasterService
  ) {}

  printConfig: any = {
    title: "Party Order report",
    columns: [],
    rows: [],
  };

  ngOnInit(): void {
    this.LoadFinYearList();
    this.LoadAgentList();
    if (this.menu.config_wo_type == "sales") {
      this.columns = [
        //{ width: 30, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: false, checkboxable :true},
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          summaryFunc: (cells) => "Sample",
        },
        {
          name: "Name",
          prop: "party_name",
          minWidth: 250,
          maxWidth: 250,
          width: 250,
        },
        {
          name: "Sales Qty",
          prop: "totqty",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
      ];
    } else if (this.menu.config_wo_type == "orders") {
      this.columns = [
        //{ width: 30, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: false, checkboxable :true},
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          summaryFunc: (cells) => "Sample",
        },
        {
          name: "Name",
          prop: "party_name",
          minWidth: 250,
          maxWidth: 250,
          width: 250,
        },
        {
          name: "Sales Qty",
          prop: "totqty",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
      ];
    }

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterpartyName").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getPartySalesOrder();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getPartySalesOrder();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getPartySalesOrder();
  }

  getPartySalesOrder(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      // name:this.filterData.name,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      //   filter: JSON.stringify(this.filter),
      filter: this.filterData.fin_id,
      filterdata: this.filterData.genLedid,
      // tabTitle: this.title
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .getPartySalesOrder(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.dataList = res.data;
        that.page.count = res.data.length;
        that.printConfig = {
          title: "Party Sales Order report",
          columns: that.columns,
          rows: that.dataList,
        };
        that.exceldata = that.getData(that.columns, res.data);
        that.refreshData();
        //  that.columns = res.columns;
      });
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  clearFilter(): void {
    this.filterData = {
      fin_id: "",
    };
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getPartySalesOrder();
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "FinYear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  LoadFinYearList() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      this.getPartySalesOrder();
    });
  }

  displayFn1(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Agent") {
      list = this.agentList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { genLedid: id });
      return fitem["name"];
    }
    return "";
  }

  LoadAgentList() {
    let that = this;
    this.salesplanservice.getAgentList({}).then((res: any) => {
      that.agentList = res.data;
    });
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/PartyOrderQty/PartyOrderQtyReport.ts